import { PAGE_VIEW_EVENT } from "@zapier/canvas-constants";
import { currentAccountIdAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

export function useEmitPageViewEvent() {
  const currentAccountId = useAtomValue(currentAccountIdAtom);
  useEffect(() => {
    if (window.EventToolkit?.emit) {
      window.EventToolkit.emit(
        {
          system_name: "canvas",
          account_id: currentAccountId,
        },
        PAGE_VIEW_EVENT,
      );
    }
  }, [currentAccountId]);
}
